import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const StressLevel = lazyWithPreload(() => import('./StressLevel'))
